module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    attrs: {
      "id": "band"
    }
  }, [_c('heading', {
    attrs: {
      "text": _vm.band.name,
      "level": 2,
      "font": "oswald",
      "color": "yellow",
      "variant": "uppercase"
    }
  }), _vm._v(" "), _c('large-picture', {
    attrs: {
      "src": _vm.band.picture,
      "alt": _vm.band.name
    }
  }), _vm._v(" "), _c('section', [_c('heading', {
    attrs: {
      "text": _vm.$t('encyclopedia.sheet'),
      "level": 3,
      "font": "oswald",
      "color": "black"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "style"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.$t('encyclopedia.style')))]), _vm._v(" "), _c('span', {
    staticClass: "light"
  }, [_vm._v(_vm._s(_vm.band.style))])]), _vm._v(" "), _c('div', {
    staticClass: "status"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.$t('encyclopedia.status')))]), _vm._v(" "), _c('span', {
    staticClass: "light"
  }, [_vm._v(_vm._s(_vm.band.status))])]), _vm._v(" "), _c('div', {
    staticClass: "creationDate"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.$t('band.creation')))]), _vm._v(" "), (_vm.band.creationDate !== '0000') ? _c('span', {
    staticClass: "light"
  }, [_vm._v(_vm._s(_vm.band.creationDate))]) : _c('span', {
    staticClass: "light"
  }, [_vm._v("N/A")])]), _vm._v(" "), (_vm.band.splitDate !== '0000') ? _c('div', {
    staticClass: "splitDate"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.$t('band.split')))]), _vm._v(" "), _c('span', {
    staticClass: "light"
  }, [_vm._v(_vm._s(_vm.band.splitDate))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.$t('encyclopedia.country')))]), _vm._v(" "), _c('span', {
    staticClass: "light"
  }, [_vm._v(_vm._s(_vm.band.country))])]), _vm._v(" "), _c('div', {
    staticClass: "region"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.$t('encyclopedia.region')))]), _vm._v(" "), _c('span', {
    staticClass: "light"
  }, [_vm._v(_vm._s(_vm.band.region))])]), _vm._v(" "), _c('div', {
    staticClass: "city"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.$t('encyclopedia.city')))]), _vm._v(" "), (_vm.band.city) ? _c('span', {
    staticClass: "light"
  }, [_vm._v(_vm._s(_vm.band.city))]) : _c('span', {
    staticClass: "light"
  }, [_vm._v("N/A")])]), _vm._v(" "), _c('div', {
    staticClass: "popularity"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.$t('band.popularity')))]), _vm._v(" "), _c('span', _vm._l((_vm.band.popularity), function(star) {
    return _c('icon', {
      key: star,
      staticClass: "light",
      attrs: {
        "name": "star",
        "scale": "1"
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "nbFans"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.$t('band.fans')))]), _vm._v(" "), _c('span', {
    staticClass: "light"
  }, [_vm._v(_vm._s(_vm.band.nbFans))])])])], 1), _vm._v(" "), _c('section', [_c('heading', {
    attrs: {
      "text": _vm.$t('band.lineup'),
      "level": 3,
      "font": "oswald",
      "color": "black"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "info lineup"
  }, _vm._l((_vm.band.lineup), function(member) {
    return _c('li', [_c('span', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(member.name))]), _vm._v(" "), _c('span', {
      staticClass: "light"
    }, [_vm._v(_vm._s(member.instruments))])])
  }))], 1), _vm._v(" "), (_vm.band.formerMembers !== null) ? _c('section', [_c('heading', {
    attrs: {
      "text": _vm.$t('band.formerMembers'),
      "level": 3,
      "font": "oswald",
      "color": "black"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "info formerMembers"
  }, _vm._l((_vm.band.formerMembers), function(member) {
    return _c('li', [_c('span', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(member.name))]), _vm._v(" "), _c('span', {
      staticClass: "light"
    }, [_vm._v(_vm._s(member.instruments))])])
  }))], 1) : _vm._e(), _vm._v(" "), _c('section', [_c('heading', {
    attrs: {
      "text": _vm.$t('band.discography'),
      "level": 3,
      "font": "oswald",
      "color": "black"
    }
  }), _vm._v(" "), _c('nav', [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'fullLength'
      }
    }
  }, [_vm._v("Albums")])], 1), _vm._v(" "), _c('li', [_vm._v("›")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'eps'
      }
    }
  }, [_vm._v("EPs")])], 1), _vm._v(" "), _c('li', [_vm._v("›")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'singles'
      }
    }
  }, [_vm._v("Singles")])], 1), _vm._v(" "), _c('li', [_vm._v("›")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'demos'
      }
    }
  }, [_vm._v("Démos")])], 1), _vm._v(" "), _c('li', [_vm._v("›")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'compilations'
      }
    }
  }, [_vm._v("Compilations")])], 1), _vm._v(" "), _c('li', [_vm._v("›")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'lives'
      }
    }
  }, [_vm._v("Lives")])], 1), _vm._v(" "), _c('li', [_vm._v("›")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'splits'
      }
    }
  }, [_vm._v("Splits")])], 1), _vm._v(" "), _c('li', [_vm._v("›")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'vids'
      }
    }
  }, [_vm._v("Vidéos")])], 1), _vm._v(" "), _c('li', [_vm._v("›")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'bootlegs'
      }
    }
  }, [_vm._v("Bootlegs")])], 1), _vm._v(" "), _c('li', [_vm._v("›")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'boxSets'
      }
    }
  }, [_vm._v("Box sets")])], 1), _vm._v(" "), _c('li', [_vm._v("›")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'tributes'
      }
    }
  }, [_vm._v("Tributes")])], 1)])]), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), (_vm.$loading) ? _c('loader') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17c027ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/router-views/encyclopedia/Band.vue
// module id = 247
// module chunks = 0